<template>
    <v-toolbar 
        flat
    >
        <span class="toolbar-title">Tickets</span>
        <v-spacer />       
        <TicketMapNavButtons />
    </v-toolbar>
</template>
<script>
import TicketMapNavButtons from './TicketMapNavButtons';

export default {
    components: {
        TicketMapNavButtons
    },
    props: {
        selectedTickets: {
            type: Array,
            default: () => [],
        },
        differencesDisabled: {
            type: Boolean,
        },
        reopenDisabled: {
            type: Boolean
        },
        respondDisabled: {
            type: Boolean
        },
        assignDisabled: {
            type: Boolean
        },    
    },
    data: () => ({
        tableMapToggle: 'table',
    })    
};
</script>
<style scoped>
.toolbar-title {
    font-size: 20px;
    font-weight: 500;
}
/deep/ .v-toolbar__content {
     padding-left: 0px !important;
     padding-right: 0px !important;
}
</style>